import AudioCell from './AudioCell';

export default AudioCell;
